"use client";

import { FAQSection } from "../design-system/organisms/FAQSection";
import type { BlockProps } from "./blocks/registry";

type StrapiMedia = {
  url?: string;
};

type FaqItem = {
  id?: number | string;
  titre?: string;
  descr?: string;
};

type FaqBlockData = {
  id?: number | string;
  documentId?: string;
  __component?: string;
  titre?: string;
  descr?: string;
  faqItem?: FaqItem[];
  image?: StrapiMedia;
  [key: string]: unknown;
};

type MappedFaqItem = {
  id: string;
  question: string;
  answer: string;
};

type MappedFaqData = {
  title: string;
  subtitle: string;
  items: MappedFaqItem[];
  image: string;
};

export function mapFaqData(strapiData: FaqBlockData): MappedFaqData | null {
  if (!strapiData) return null;

  return {
    title: strapiData.titre || "",
    subtitle: strapiData.descr || "",
    items: (strapiData.faqItem || []).map((item, index) => ({
      id: String(item.id ?? `faq-${index}`),
      question: item.titre || "",
      answer: item.descr || "",
    })),

    image: strapiData.image?.url || "/fallback-image.jpg",
  };
}

export default function Faq({ data }: BlockProps<FaqBlockData>) {
  if (!data) return null;

  const faqData = mapFaqData(data);

  if (!faqData) return null;

  return <FAQSection {...faqData} />;
}